import React, { useEffect, useRef, useState } from "react";

import styles from "./language.module.scss";

import { flags } from "./assets/langList";

const LanguagePicker = ({
                            current,
                            available = [],
                            direction = "down",
                            colDirection = ["up", "down"].indexOf(direction) !== -1 ? "right" : "down",
                            rows,
                            onSave,
                            className = ""
                        }) => {
    const pickerRef = useRef();
    const language = current;

    const [style, setStyle] = useState({});

    const toggleLanguagePicker = () => {
        pickerRef.current.classList.toggle("is--active");
        pickerRef.current.dataset.active = pickerRef.current.classList.contains(
            "is--active"
        );
    };

    const handleChangeLanguage = (lang) => {
        setTimeout(function () {
            onSave(lang)
        }, 500)
    };

    const generateAvailableLanguages = () =>
        available
            // .filter((lang) => lang !== language)
            .map((lang, i) => (
                <div
                    key={`lang-selector-${lang}`}
                    className={`language-picker__container ${styles.container}`}
                    style={{
                        zIndex: language === lang ? 2 : ""
                    }}
                >
                    <div
                        className={`language-picker__language ${styles.language}`}
                        onClick={() => handleChangeLanguage(lang)}
                        style={className !== '' ? {backgroundColor: 'rgba(0,0,0,.6)'} : {}}
                    >
                        <img src={flags[lang].img} />
                        <span>{flags[lang].full}</span>
                    </div>
                </div>
            ));

    const calculateStyle = () => {
        let rectangle = pickerRef?.current?.getBoundingClientRect();

        let size = { maxHeight: "", maxWidth: "" };

        if (["down", "up"].indexOf(direction) !== -1) {
            if (direction === "down") {
                size.height = Math.floor(
                    ((window.innerHeight - 20 - (rectangle?.top || 0)) / 30) * 30
                );
            } else {
                size.height = rectangle?.top || 0;
            }
            size.maxHeight = rows ? rows * 30 : size.height;

            size.width =
                (Math.ceil(
                    (available.length - 1) / Math.floor((size?.height || 0) / 30)
                ) || 1) * 40;
        } else if (["left", "right"].indexOf(direction) != -1) {
            if (direction === "left") {
                size.width = Math.floor(
                    ((window.innerWidth - 30 - (rectangle?.left || 0)) / 40) * 40
                );
            } else {
                size.width = rectangle?.right - 40 || 0;
            }
            size.maxWidth = rows ? rows * 40 : size.width;

            size.height =
                (Math.ceil(
                    (available.length - 1) / Math.floor((size?.width || 0) / 40)
                ) || 1) * 30;
        }

        setStyle({
            width: `${size.width}px`,
            maxWidth: `${size.width}px`,
            height: `${size.height}px`,
            maxHeight: `${size.maxHeight}px`
        });
    };

    const handleResize = () => {
        calculateStyle();
    };

    useEffect(() => {
        if (rows && typeof rows !== "number") {
            throw `'rows' prop must be a number`;
        }

        if (["down", "up"].indexOf(direction) !== -1) {
            if (["left", "right"].indexOf(colDirection) === -1) {
                throw `'colDirection' prop must be 'left' or 'right'`;
            }
        } else if (["left", "right"].indexOf(direction) !== -1) {
            if (["down", "up"].indexOf(colDirection) === -1) {
                throw `'colDirection' prop must be 'down' or 'up'`;
            }
        } else {
            throw `'direction' prop must be 'down', 'up', 'left' or 'right'`;
        }
        calculateStyle();
    }, [direction, colDirection, rows]);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div
            ref={pickerRef}
            className={`language-picker ${className} ${styles.picker}`}
            data-direction={direction}
            data-col-direction={colDirection}
            onClick={toggleLanguagePicker}
        >
            <div
                className={`language-picker__current ${styles.current} ${styles.language}`}
                style={className !== '' ? {padding: '0 5px'} : {}}
            >
                <img src={flags[language].img} />
            </div>
            {available.length !== 0 && (
                <div
                    className={`language-picker__selector ${styles.selector}`}
                    style={style}
                >
                    {generateAvailableLanguages()}
                </div>
            )}
        </div>
    );
};

export default LanguagePicker;
